import { render, staticRenderFns } from "./OrderFulfillmentRateTable.vue?vue&type=template&id=a06b1d88&scoped=true"
import script from "./OrderFulfillmentRateTable.vue?vue&type=script&lang=js"
export * from "./OrderFulfillmentRateTable.vue?vue&type=script&lang=js"
import style0 from "./OrderFulfillmentRateTable.vue?vue&type=style&index=0&id=a06b1d88&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a06b1d88",
  null
  
)

export default component.exports